import React from 'react';
import classNames from 'classnames';
import styles from './PopupGenPremiumAIResponse.module.scss';
import Popup, { Props as PopupProps } from '../Popup';
import { Phrases } from '../../../utilities/constants/phrases';
import Icon, { IconGlyph } from '../../Icon';
import { renderTextWithIndexedTags } from '../../../utilities/helpers/phrases';
import Title from '../../TitleWithGradient/TitleWithGradient';
import LinearLoader, {
  Props as LinearLoaderProps,
} from '../../LinearLoader/LinearLoader';
import Rating from '../Rating/Rating';
import { EditorPopupId } from '../../../utilities/constants/popup-type';

const POPUP_ID = EditorPopupId.GEN_PREMIUM_AI_RESPONSE;
const GENERATION_DURATION = 15000;

interface Props
  extends Pick<PopupProps, 'isOpen' | 'onClose'>,
    Pick<LinearLoaderProps, 'isLoading'> {}

const PopupGenPremiumAIResponse: React.FC<Props> = ({
  isOpen,
  isLoading = false,
  onClose,
}) => (
  <Popup
    isOpen={isOpen}
    id={POPUP_ID}
    role='alertdialog'
    dialogClassName={classNames(
      styles.popupGenPremiumAIResponse,
      'd-flex flex-col flex-ai-c gap-xxxs'
    )}>
    <Icon glyph={IconGlyph.AI_ICON} />
    <Title
      title={renderTextWithIndexedTags(
        Phrases.POPUP_GEN_PREMIUM_AI_RESPONSE_TITLE,
        [<span key='span-0' />]
      )}
      className='text-xl fw-bold ta-center mt-xs'
    />
    <LinearLoader
      isLoading={isLoading}
      onSuccess={onClose}
      color='gradient'
      duration={GENERATION_DURATION}
      className={classNames(styles.linearLoader, 'mt-xs')}
    />
    <Rating />
  </Popup>
);

export default PopupGenPremiumAIResponse;
